import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appOrderBy',
  standalone: true,
})
export class OrderByPipe<T extends { [key: string]: any }> implements PipeTransform {
  public transform(array: T[], field: string, nestedField: string, disabled: boolean = false, reverse?: boolean): T[] {
    if (disabled) {
      return array;
    }

    const isAscending = reverse ? -1 : 1;
    let returnArray = [...array]

    return returnArray.sort((a, b) => {
      if (a[field][nestedField] < b[field][nestedField]) {
        return -1 * isAscending;
      } else if (a[field][nestedField] > b[field][nestedField]) {
        return 1 * isAscending;
      } else {
        return 0;
      }
    });
  }
}
